import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
  Routes,
} from '@angular/router';
import {JhiResolvePagingParams} from 'ng-jhipster';
import {of} from 'rxjs';
import {map} from 'rxjs/operators';

import {IVaiTro, VaiTro} from '@entities/vai-tro/vai-tro.model';
import {VaiTroService} from '@entities/vai-tro/vai-tro.service';
import {IUser, User, UserRouteAccessService, UserService} from '@app/core';
import {UserMgmtDeletePopupComponent} from '@app/admin/user-management/user-management-delete-dialog/user-management-delete-dialog.component';
import {UserManagementUpdatePopupComponent} from '@app/admin/user-management/user-management-update/user-management-update.component';
import {UserMgmtComponent} from '@app/admin/user-management/user-management/user-management.component';
import {UserRoleDeletePopupComponent} from '@app/admin/user-management/user-role-delete-dialog/user-role-delete-dialog.component';
import {UserRolePopupComponent} from '@app/admin/user-management/user-role-update/user-role-update.component';
import {UserRoleComponent} from '@app/admin/user-management/user-role/user-role.component';

// @Injectable({providedIn: 'root'})
// export class UserResolve implements CanActivate {
//   constructor(private principal: Principal) {
//   }

//   canActivate() {
//     return this.principal.identity().then(account => this.principal.hasAnyAuthority(['ROLE_ADMIN']));
//   }
// }

@Injectable({providedIn: 'root'})
export class UserManagementResolve implements Resolve<IUser> {
  constructor(private service: UserService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const id = route.params['login'] ? route.params['login'] : null;
    if (id) {
      return this.service
        .findById(id)
        .pipe(map((user: HttpResponse<User>) => user.body));
    }
    return of(new User());
  }
}

@Injectable({providedIn: 'root'})
export class UserRoleResolve implements Resolve<IVaiTro> {
  constructor(private service: VaiTroService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const id = route.params['id'] ? route.params['id'] : null;
    if (id) {
      return this.service
        .find(id)
        .pipe(map((role: HttpResponse<VaiTro>) => role.body));
    }
    return of(new VaiTro());
  }
}

@Injectable({providedIn: 'root'})
export class UserAuthoritiesResolve implements Resolve<string[]> {
  constructor(private service: UserService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.service.authorities();
  }
}

export const userManagementRoute: Routes = [
  {
    path: 'danh-sach-nguoi-dung',
    component: UserMgmtComponent,
    resolve: {
      pagingParams: JhiResolvePagingParams,
    },
    data: {
      authorities: ['can_read_user'],
      pageTitle:
        'admin.user-management.user-management.Danh sách người dùng_title',
      defaultSort: 'id,asc',
    },
    canActivate: [UserRouteAccessService],
  },
  {
    path: 'phan-quyen-nguoi-dung',
    component: UserRoleComponent,
    data: {
      authorities: ['can_read_role'],
      pageTitle:
        'admin.user-management.user-management.Danh sách phân quyền_title',
    },
    canActivate: [UserRouteAccessService],
  },
];

export const userManagementPopupRoute: Routes = [
  {
    path: 'them-nguoi-dung',
    component: UserManagementUpdatePopupComponent,
    resolve: {
      user: UserManagementResolve,
      // authorities: UserAuthoritiesResolve,
    },
    data: {
      authorities: ['can_create_user'],
      pageTitle: 'admin.user-management.user-management.Thêm người dùng_title',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'sua-nguoi-dung/:login',
    component: UserManagementUpdatePopupComponent,
    resolve: {
      user: UserManagementResolve,
    },
    data: {
      authorities: ['can_update_user'],
      pageTitle: 'admin.user-management.user-management.Sửa người dùng_title',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'xoa-nguoi-dung/:login',
    component: UserMgmtDeletePopupComponent,
    resolve: {
      user: UserManagementResolve,
    },
    data: {
      authorities: ['can_delete_user'],
      pageTitle: 'admin.user-management.user-management.Xóa người dùng_title',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'them-vai-tro',
    component: UserRolePopupComponent,
    resolve: {
      role: UserRoleResolve,
    },
    data: {
      authorities: ['can_create_role'],
      pageTitle: 'admin.user-management.user-management.Thêm vai trò_title',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'sua-vai-tro/:id',
    component: UserRolePopupComponent,
    resolve: {
      role: UserRoleResolve,
    },
    data: {
      authorities: ['can_update_role'],
      pageTitle: 'admin.user-management.user-management.Sửa vai trò_title',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
  {
    path: 'xoa-vai-tro/:id',
    component: UserRoleDeletePopupComponent,
    resolve: {
      role: UserRoleResolve,
    },
    data: {
      authorities: ['can_delete_role'],
      pageTitle: 'admin.user-management.user-management.Xóa vai trò_title',
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup',
  },
];
